import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import api from '../../utils/axiosInstance';
import { adminStats } from '../../constant/routes';
import './Admin.css';

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const location = useLocation();

    useEffect(() => {
        api.get(adminStats)
            .then(r => { if (r.status === 200) setStats(r.data); })
            .catch(() => {});
    }, []);

    const nav = [
        { to: '/admin/products', label: 'Products' },
        { to: '/admin/orders',   label: 'Orders'   },
        { to: '/admin/blogs',    label: 'Blogs'    },
    ];

    const isIndex = location.pathname === '/admin';

    return (
        <div className='adminLayout'>
            <aside className='adminSidebar'>
                <h2>Admin</h2>
                <nav>
                    {nav.map(({ to, label }) => (
                        <NavLink
                            key={to}
                            to={to}
                            className={({ isActive }) =>
                                isActive ? 'adminNavLink active' : 'adminNavLink'
                            }
                        >
                            {label}
                        </NavLink>
                    ))}
                </nav>
            </aside>

            <main className='adminContent'>
                {stats && (
                    <div className='adminStats'>
                        <div className='statCard'>
                            <h3>{stats.totalProducts}</h3>
                            <p>Products</p>
                        </div>
                        <div className='statCard'>
                            <h3>{stats.totalOrders}</h3>
                            <p>Orders</p>
                        </div>
                        <div className='statCard'>
                            <h3>{stats.totalUsers}</h3>
                            <p>Users</p>
                        </div>
                    </div>
                )}

                {isIndex && (
                    <div className='adminWelcome'>
                        <h3>Welcome to the Admin Dashboard</h3>
                        <p>Select a section from the sidebar to manage your store.</p>
                    </div>
                )}

                <Outlet />
            </main>
        </div>
    );
};

export default AdminDashboard;
